// extracted by mini-css-extract-plugin
module.exports = {"field":"Field_field_RpiFV","label":"Field_label_2-1iY","message":"Field_message_1kJPo","mandatory":"Field_mandatory_3t0p3"};